import React from 'react';
import {Spring, animated} from 'react-spring/renderprops';
import {css} from 'emotion';
import styled from 'styled-components';

/*global tw*/

const RCBStyles = {
    activeIndicator: css`
        ${tw`absolute z-10`};
        left: 0;
        top: 30%;
        bottom: 0;
        height: 5rem;
        width: 3px;
        background: linear-gradient(180deg, #B15CFF 0%, #8B3DF5 100%);
        border-radius: 0 2px 2px 0;
    `,
}

const RentingChoice = styled.div`
    ${tw`relative overflow-hidden flex items-center lg:mx-4 px-5 lg:px-8 py-6 my-3 cursor-pointer`};
    /* Mobile: icon + text on one row. Desktop: stacked 4-up card. */
    flex-wrap: nowrap;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.09);
    border-radius: 14px;
    transition: all 0.2s ease;
    height: auto;
    width: 100%;
    font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    @media (min-width: 992px){
        flex-wrap: wrap;
        align-content: center;
        height: 16rem;
        width: calc(25% - 2rem);
    }
    &:hover {
        border-color: rgba(177, 92, 255, 0.5);
        box-shadow: 0 16px 40px rgba(0, 0, 0, 0.4);
        transform: translateY(-4px);
    }
    &:hover .rc-icon {
        border-color: rgba(177, 92, 255, 0.6);
        background: rgba(177, 92, 255, 0.2);
    }
`

const IconWrap = styled.div`
    ${tw`inline-flex items-center justify-center flex-shrink-0`};
    width: 3rem;
    height: 3rem;
    border-radius: 12px;
    background: rgba(177, 92, 255, 0.14);
    border: 1px solid rgba(177, 92, 255, 0.32);
    color: #C9A2FF;
    margin-right: 1.25rem;
    transition: all 0.2s ease;
    @media (min-width: 992px){
        width: 3.25rem;
        height: 3.25rem;
        margin-right: 0;
        margin-bottom: 1rem;
    }
`

const ChoiceDescription = styled.div`
    flex: 1 1 auto;
    min-width: 0;
    @media (min-width: 992px){
        flex: 1 1 100%;
    }
    h3 {
        ${tw`m-0 text-xl lg:text-2xl tracking-tight`};
        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
        font-weight: 700;
        color: #FFFFFF;
        letter-spacing: -0.02em;
    }
    p {
        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
        font-size: 0.9375rem;
        color: rgba(255, 255, 255, 0.68);
        margin-top: 0.375rem;
        line-height: 1.5;
    }
`

const RentingChoiceButton = (props) => (
    <RentingChoice onClick={props.onClick}>
        <IconWrap className="rc-icon">{props.icon}</IconWrap>
        <ChoiceDescription>
            <h3>{props.title}</h3>
            <p>{props.description}</p>
        </ChoiceDescription>
        <Spring
            native
            from={{ o: 0, x: -200 }}
            to={{ o: props.active ? 1 : 0, x: props.active ? 0 : -200 }}>
            {({ x }) => (
                <animated.div
                    style={{ transform: x.interpolate(x => `translate3d(${x}px, 0, 0)`) }}
                    className={RCBStyles.activeIndicator}>
                </animated.div>
            )}
        </Spring>
    </RentingChoice>
);

export default RentingChoiceButton;
